import React, {Component} from 'react';
import PropTypes from "prop-types";
import {DataTable} from "react-data-components";
import ModalDeletePerson from './ModalDeletePerson';
import moment from 'moment';
import {Link} from 'react-router-dom';
import DatePicker from 'react-datepicker';
import userImage from '../../../assets/img/128x128.jpg';
import { Scrollbars } from 'react-custom-scrollbars';
import {NotificationManager} from 'react-notifications';
import api from '../../../utils/api';
import 'react-datepicker/dist/react-datepicker.css';

class PeopleStudents extends Component {
    state={
        columns: [],
        students: [...this.props.students],
        showingDeleteUser: false,
        deleteUserId: null,
        columnsTable: [],
        search: ''
    };

    //Renders
    renderImg = (val, row) => {
        if(row.Profile){
            let avatar = userImage;
            if(row.Profile.image){
                if(row.Profile.image.indexOf('http') > -1){
                    avatar = row.Profile.image;
                }else{
                    avatar = api.makeFileURL(row.Profile.image, this.props.user.id);
                }
            }
            return (
                <img
                    className="chat-avatar"
                    src={avatar}
                    alt={row.Profile.name}
                />
            )
        }else{
            return (
                <img
                    className="chat-avatar"
                    src={userImage}
                    alt={row.Profile.name}
                />
            )
        }
    };

    loadMore = () => {
        if(this.state.search === ''){
            this.props.getStudentsByCourse(this.props.courseId, this.props.user.id, this.props.students.length);
            
        }else{
            let where = {or: []};

            let terms = this.state.search.split(' ');
            terms.map(t => {
                if(t.indexOf('=') > -1){
                    let splitted = t.split('=');
                    where.or.push({[splitted[0]]: {like: splitted[1]}});
                }else{
                    where.or.push({email: {like: t}});
                    where.or.push({name: {like: t}});
                    where.or.push({role: {like: t}});
                    where.or.push({status: {like: t}});
                    where.or.push({lastActive: {like: t}});
   
                }
            })
            if(this.props.courseId){
                where['courseId'] = this.props.courseId;
                where['role'] = "student";
            }

            this.props.findStudentsByCourse(where, this.props.courseId, this.props.user.id, 0);
        }
    }

    renderSearch = () => {
        return (
            <form onSubmit={e => {
                e.preventDefault();
                if(this.state.search === ''){
                    this.props.getStudentsByCourse(this.props.courseId, this.props.user.id, 0);
                    
                }else{
                    let where = {or: []};
    
                    let terms = this.state.search.split(' ');
                    terms.map(t => {
                        if(t.indexOf('=') > -1){
                            let splitted = t.split('=');
                            where.or.push({[splitted[0]]: {like: splitted[1]}});
                        }else{
                            where.or.push({email: {like: t}});
                            where.or.push({name: {like: t}});
                            where.or.push({role: {like: t}});
                            where.or.push({status: {like: t}});
                            where.or.push({lastActive: {like: t}});
           
                        }
                    })
                    if(this.props.courseId){
                        where['courseId'] = this.props.courseId;
                        where['role'] = "student";
                    }
    
                    this.props.findStudentsByCourse(where, this.props.courseId, this.props.user.id, 0);
                }
            }}>
                <input type="text" className="form-control darkInput pull-right" placeholder="Search" style={{display: 'inline-block', width: '350px', backgroundColor: '#222 !important'}} value={this.state.search} onChange={e => this.setState({search: e.target.value})} /> 
                <button  style={{display: 'inline-block', position: 'absolute', right: '20px', fontSize: '24px'}} className="btn btn-transparent"><i className="zmdi zmdi-search" /></button>
            </form>
        )
    }


    hideModalDelete = () => {
        this.setState({showingDeleteUser: false});
    }

    renderThumb = ({ style, ...props }) => {
        const { top } = this.state;
        const thumbStyle = {
            backgroundColor: `rgba(255,255,255,.2)`
        };
        return (
            <div
                className="rail"
                style={{ ...style, ...thumbStyle }}
                {...props}/>
        );
    }

    renderTableButton = (button, name) => (
        <button
            className={"btn btn-default buttons-html5 buttons-"+button }
            tabIndex="0"
            aria-controls="DataTables_Table_0"
        >
            <span>{name}</span>
        </button>
    );


    renderCheckbox = () => (
        this.state.columnsTable.map((item, index) => (
            <li key={index}>
                <label>
                    <input
                        type="checkbox"
                        value={index}
                        defaultChecked={item.defaultChecked}
                        onChange={this.handleChangeInput}
                    />
                    {item.title}
                </label>
            </li>
        ))
    );

    //Actions
    handleChangeInput = (event) => {

        if (event.target.checked === true) {
            let val = this.state.columns.find(item => item.value > +event.target.value);

            if (val){
                this.state.columns.map((item, index) => {
                    if (item.value === val.value) {
                        return val = index;
                    }
                    return val;
                });
            } else {
                val = event.target.value;
            }


            this.state.columns.splice(val, 0,  this.state.columnsTable[event.target.value]);
            this.setState({columns: this.state.columns});

        } else {
            this.state.columns.map((item, index) => {
                if(item.value === event.target.value) {
                    this.state.columns.splice(index, 1 );
                    this.setState({columns: this.state.columns});
                }
                return item
            });
        }
    };

    renderControlsForTable = () => (
        <div className="border-bottom sp-10">
            <div className="clearfix">
                <div className="pull-left">
                    <div className="btn-group">
                        <div className="dropdown">
                            <a
                                role="button"
                                data-toggle="dropdown"
                                className="btn btn-default"
                            >
                                Show/Hide Columns
                            </a>
                            <ul className="dropdown-menu showHidColumns">
                                {this.renderCheckbox()}
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="pull-right">
                    <div className="dt-buttons btn-group">
                        {this.renderTableButton('copy', 'Copy')}
                        {this.renderTableButton('excel', 'Excel')}
                        {this.renderTableButton('pdf', 'PDF')}
                    </div>
                </div>
            </div>
        </div>
    );


    renderActions = (val, row) => (
        <div className="dropdown">
            <a
                href="#"
                className="btn btn-default"
                data-toggle="dropdown"
                aria-expanded="false"
            >
                Actions <i className="zmdi zmdi-caret-down"/>
            </a>
            <ul className="dropdown-menu w-lg pull-right fixed-width-icons">
                <li>
                    <a role="button">
                        <i className="zmdi zmdi-undo"/>
                        Undo
                    </a>
                </li>
                {row.status === 'blocked' ?
                    <li>
                        <a role="button"
                           onClick={(e) => {
                               row.status = "approved";
                               this.props.updateCourseUser(row, this.props.user.id);
                           }}
                        >
                            <i className="zmdi zmdi-play"/>
                            Resume
                        </a>
                    </li>

                    :

                    <li>
                        <a role="button"
                           onClick={(e) => {
                               row.status = "blocked";
                               this.props.updateCourseUser(row, this.props.user.id);
                           }}
                        >
                            <i className="zmdi zmdi-pause"/>
                            Hold
                        </a>
                    </li>
                }
                <li>
                    <a
                        role="button"
                        onClick={()=>{this.setState({showingDeleteUser: true, deleteUserId: row.id})}}
                    >
                        <i className="zmdi zmdi-delete"/>
                        Delete
                    </a>
                </li>
            </ul>
        </div>
    );

    renderCourses = (val, row) => {


        if(row.Course) {
            return (
                <span>{row.Course.name}</span>
            )
        }
    }

    renderCoursesOld = (val, row) => (
        <select
            className="form-control"
            defaultValue={val}
            onChange={(e) => {
                e.preventDefault();
                this.props.editCoursesStudent(e.target.value, row.id);
            }}
        >
            {this.props.courses.map(c => {
                return (
                    <option value={c.id}>{c.name}</option>
                )
            })}
        </select>
    );

    renderReferrals = (val, row) => (
        <input
            type="number"
            className="form-control"
            defaultValue={row.referrals || 0}
            onChange={(e) => {
                e.preventDefault();
                row.referrals = e.target.value;
                this.props.updateCourseUser(row, this.props.user.id);
            }}
        />
    );

    renderDate = (val, row) => (
        <input
            type="date"
            className="form-control"
            defaultValue={val}
            onChange={(e) => {
                e.preventDefault();
                this.props.editAccessStudent(e.target.value, row.id);
            }}
        />
    );

    renderMoment = (val, row) => (
        <span className="text-center">{moment(val).format('MMM DD YYYY @ HH:mm:ss')}</span>
    );

    

    renderLastActive = (val, row) => {
        if(row.lastActive) {

            return (
                <span className="text-center">{moment(row.lastActive).format('MMM DD YYYY @ HH:mm:ss')}</span>
            )
        }

    }

    renderNextPayment = (val, row) => (
        <input
            type="date"
            className="form-control"
            defaultValue={val}
            onChange={(e) => {
                e.preventDefault();
                this.props.editNextPaymentStudent(e.target.value, row.id);
            }}
        />
    );

    renderStatus = (val, row) =>  {
        return (
            <span
                className={`label label-${
                    (row.status === 'blocked')
                        ? 'danger'
                        : (row.status === 'approved')
                        ? 'success'
                        : 'warning'
                    }
            `}
            >
            {row.status.toUpperCase()}
        </span>
        )
    }


    renderName = (val, row) => {
        let title = (row.Profile.name) ? row.Profile.name : row.Profile.email;

        return (
            <Link to={'/student-profile/' + row.Profile.id}>
                {title}</Link>
        )
    }

    renderActivityStatus = (val, row) => {
        let la = moment(row.lastActive);
        let diff = moment(new Date()).diff(la, 'days');
        let status = 'Active';

        if(row.completed){
            status = 'Completed';
        }else if(diff > 60){
            status = 'Inactive';
        }else if(status === 'blocked'){
            status = 'Disabled';
        }
        return (
            <span>{status}</span>
        )
    }

    renderCurrentSubject = (val, row) => {
        let subjectName = '';

        this.props.courses.map(c => {
            c.CourseSubject.map(s => {
                if(s.id === val){
                    subjectName = s.name;
                }
            })
        })

        return (
            <span>{subjectName}</span>
        )
    }

    renderCourseProgress = (val, row) => {

        return (
            <span>{row.completionPercent || 0}</span>
        )
    }

    renderSelect = () => (
        <select
            onChange={(e) => {
                e.preventDefault();
                this.handleChangeSelect(e);
            }}
        >
            <option>All Students</option>
            <option>MCAT</option>
            <option>LSAT</option>
        </select>
    );

    //Actions
    handleChangeSelect = (e) => {
        if (e.target.value === 'All Students') {
            this.setState({studentsPeople:  this.props.studentsPeople});
        } else {
            this.setState({studentsPeople:  this.props.studentsPeople.filter(item=> item.courses=== e.target.value)});
        }
    };

    updateExpiry = (d, courseUser) => {

        courseUser.expiry = d;
        this.props.updateCourseUser(courseUser, this.props.user.id);


    }

    renderExpiry = (val, row) => {
        return (
            <DatePicker
                selected={moment(row.expiry) || ''}
                onChange={(e) => this.updateExpiry(e, row)}
                className="form-control"
            />
        )
    }


    updateNextPayment = (d, courseUser) => {

        courseUser.nextPayment = d;
        this.props.updateCourseUser(courseUser, this.props.user.id);


    }

    renderNextPayment = (val, row) => {
        return (
            <DatePicker
                selected={moment(row.nextPayment) || ''}
                onChange={(e) => this.updateNextPayment(e, row)}
                className="form-control"
            />
        )
    }
    renderAverageSession = (val, row) => {
        let formattedTime = 'NA';
        if(row.user){
            if(row.user){
                let sessionCount = row.user.Logins.length;
                let totalTime = row.currentUserTime;
                if(row.studied){
                    row.studied.map(p => {
                        totalTime += p.time;
                    });
                }

                if(sessionCount && totalTime){
                    let sessionTime = parseInt(totalTime / sessionCount);
                    formattedTime = moment.utc(sessionTime * 1000).format('HH:mm:ss');
                }
            }
        }
        
        return (
            <span>{formattedTime}</span>
        )

    }

    renderAllCourses = (val, row) => {
        let courseIds = [];

        this.props.students.filter(s => s.Profile).filter(s => s.Profile.id === row.Profile.id).map(cu => {
            if(cu.Course){
                courseIds.push(cu.Course.id);
            }
        });


        return (
            <div className={"form-group"}>
                <select
                    className="form-control"
                    id={`addtocourse-${row.id}`}
                >
                    <option value={""}>Select course</option>
                    {this.props.courses.map(c => {
                        return (
                            <option value={c.id} disabled={(courseIds.indexOf(c.id) > -1)}>{c.name}</option>
                        )
                    })}
                </select>
                <span className={""}>
                <button className="btn btn-transparent" onClick={(e) => {
                    let courseId = document.getElementById('addtocourse-' + row.id).value;

                    if(courseId){
                        let courseUser = {
                            profileId: row.Profile.id,
                            courseId: courseId,
                            role: row.role,
                            name: row.Profile.name,
                            email: row.Profile.email,
                            created: new Date(),
                            completedSubjects: [],
                            completedChapters: [],
                            completedChapterParts: [],
                            currentSubject: 0,
                            currentChapter: 0,
                            currentChapterPart: 0,
                            lastActive: new Date(),
                            status: 'approved'
                        }
                        this.props.createCourseUser(courseUser, this.props.user.id);

                    }else{
                        NotificationManager.error('You must select a course.', 'Error');
                    }
                }}><i className="zmdi zmdi-plus" /></button>
                </span>
            </div>
        )


    }

    renderExpectedScore = (val, row) => {
        if(row.UserTest){
            let totalScores = 0;
            row.UserTest.map(t => {
                if(t.correctPercent) {
                    totalScores += t.correctPercent;
                }
            })
            let correctPercent = parseInt(totalScores / row.UserTest.length);
            return (
                <span className={
                    (correctPercent < 40) ?
                        'text-danger' :
                        (correctPercent > 80) ?
                            'text-success' :
                            'text-warning'

                }>
                    {correctPercent}%
                </span>
            )
        }else{
            return (
                <span>N/A</span>
            )
        }
    }

    renderScoring90 = (val, row) => {
        if(row.UserTest){
            let totalScores = 0;
            row.UserTest.map(t => {
                if(t.correctPercent) {
                    totalScores += t.correctPercent;
                }
            })
            let correctPercent = parseInt(totalScores / row.UserTest.length);
            return (
                <span>
                    {correctPercent >= 90 ?
                        <i className="text-success zmdi zmdi-check" />
                        :
                        <i className="text-danger zmdi zmdi-close" />
                    }
                </span>
            )
        }else{
            return (
                <span>N/A</span>
            )
        }
    }

    renderOfficialScore = (val, row) => {
        let score = 'NA';
        if(row.Profile){
            if(row.Profile.onboardingTest){
                if(row.Profile.onboardingTest.testScore){
                    score = row.Profile.onboardingTest.testScore;
                }
            }
        }
        return (
            <span>{score}</span>
        )
    }

    //Lifecycle
    componentDidMount() {
        this.props.onLoadCourses(this.props.user.userId);
        if(this.props.courseId){
            if(window.location.href.indexOf('people') > -1){
                this.props.getStudentsByCourse(this.props.courseId, this.props.user.id, null);
            }else{
                this.props.getStudentsByCourse(this.props.courseId, this.props.user.id, 0);
            }
            this.props.getTotalStudentCount(this.props.courseId, this.props.user.id);
        }else {
            this.props.getStudents(this.props.user.id);
        }

        this.setState({
            columns: [
                {title: '', className: 'sorting_1', render: this.renderImg, defaultChecked: true, value: 0},
                {title: 'Name', className: 'v-middle', render: this.renderName, defaultChecked: true, value: 1},
                {title: 'Course', className: 'v-middle', render: this.renderCourses, defaultChecked: true, value: 2},
                {title: 'Status', className: 'v-middle', render: this.renderStatus, defaultChecked: true, value: 3},
                {title: 'Last Active', className: 'v-middle', render: this.renderLastActive, defaultChecked: true, value: 4},
                {title: 'Access', className: 'v-middle', render: this.renderExpiry, defaultChecked: true, value: 5},
                {title: 'Next Payment', className: 'v-middle', render: this.renderNextPayment, defaultChecked: true, value: 6},
                {title: 'Referrals', className: 'v-middle', render: this.renderReferrals, defaultChecked: true, value: 7},
                {title: 'Add to course', className: 'v-middle form-inline min200', defaultChecked: true, value: 22, render: this.renderAllCourses},
                {title: 'Actions', prop: 'id', className: 'v-middle', render: this.renderActions, defaultChecked: true, value: 23}
            ],
            columnsTable: [
                {title: '', className: 'sorting_1', render: this.renderImg, defaultChecked: true, value: 0},
                {title: 'Name', className: 'v-middle', render: this.renderName, defaultChecked: true, value: 1},
                {title: 'Course', className: 'v-middle', render: this.renderCourses, defaultChecked: true, value: 2},
                {title: 'Status', className: 'v-middle', render: this.renderStatus, defaultChecked: true, value: 3},
                {title: 'Last Active', className: 'v-middle', render: this.renderLastActive, defaultChecked: true, value: 4},
                {title: 'Access', className: 'v-middle', render: this.renderExpiry, defaultChecked: true, value: 5},
                {title: 'Next Payment', className: 'v-middle', render: this.renderNextPayment, defaultChecked: true, value: 6},
                {title: 'Referrals', className: 'v-middle', render: this.renderReferrals, defaultChecked: true, value: 7},

                {title: 'Avg S. Time', className: 'v-middle', defaultChecked: false, value: 8, render: this.renderAverageSession},
                {title: 'Test Date', prop: 'testDate',className: 'v-middle', defaultChecked: false, value: 9, render: this.renderMoment},
                {title: 'Started', prop: 'created', className: 'v-middle', defaultChecked: false, value: 10, render: this.renderMoment},
                {title: 'Official Score', className: 'v-middle', defaultChecked: false, value: 11, render: this.renderOfficialScore},
                {title: 'IM Response', prop: 'im', className: 'v-middle', defaultChecked: false, value: 12},
                {title: 'Activity Status', defaultChecked: false, className: 'v-middle', value: 13, render: this.renderActivityStatus},
                {title: 'Course GP', defaultChecked: false, className: 'v-middle', value: 14, render: this.renderCourseProgress},
                {title: 'Course Completion', prop: 'courseCompletion', className: 'v-middle', defaultChecked: false, value: 15},
                {title: 'Current Subject', prop: 'currentSubject', className: 'v-middle', defaultChecked: false, value: 16, render: this.renderCurrentSubject},
                {title: 'In Person', prop: 'inPerson', className: 'v-middle', defaultChecked: false, value: 17},
                {title: 'Expected Score', className: 'v-middle', defaultChecked: false, value: 18, render: this.renderExpectedScore},
                {title: 'Practice T. Score', prop: 'practiceScore', className: 'v-middle', defaultChecked: false, value: 19},
                {title: 'Scoring about 90%', className: 'v-middle', defaultChecked: false, value: 20, render: this.renderScoring90},
                {title: 'On Target', prop: 'onTarget', className: 'v-middle', defaultChecked: false, value: 21},
                {title: 'Add to course', className: 'v-middle form-inline min200', defaultChecked: true, value: 22, render: this.renderAllCourses},
                {title: 'Actions', prop: 'id', className: 'v-middle', render: this.renderActions, defaultChecked: true, value: 23}
            ]
        })


    };

    deleteUserConfirmation = () => {
        this.props.removeCourseUser(this.state.deleteUserId, this.props.user.id);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.courseId){
            if(this.props.courseId !== nextProps.courseId){
                this.props.getStudentsByCourse(nextProps.courseId, this.props.user.id)
            }
        }
        if (this.props.students !== nextProps.students) {
            this.setState({students: nextProps.students});
        }
    };

    render() {

        let {students} = this.state;

        let pages = [];
        if(this.props.studentCount){

        }
        if(this.props.courseId){
            return (
                <div>
                    <div>
                            <div className="panel-body">
                                {this.renderControlsForTable()}


                                <div className="table-responsive statistic-students table-admin">
                                {this.renderSearch()}
                                <Scrollbars style={{height: '600px'}} renderThumbHorizontal={this.renderThumb} renderThumbVertical={this.renderThumb}>
                                    <DataTable
                                        keys="id"
                                        columns={this.state.columns}
                                        initialData={students.filter(s => s.Profile)}
                                        useShowHideColumns={true}
                                        initialPageLength={999}
                                        initialSortBy={{ prop: 'created', order: 'ascending' }}
                                        pageLengthOptions={[10, 25, 50, 100]}
                                    />
                                    </Scrollbars>
                                    <div className="text-center">
                                    <button className="btn btn-primary" onClick={e => {
                                        this.loadMore();
                                    }}>Load More</button>
                                    </div>
                                </div>
                            </div>



                        {
                            this.props &&
                            <ModalDeletePerson
                                hideModalDelete={this.hideModalDelete}
                                showDeleteUser={this.state.showingDeleteUser}
                                deleteUserConfirmation={this.deleteUserConfirmation}
                                userId={this.state.deleteUserId}
                            />

                        }


                    </div>
                </div>
            )
        }else{
            return (
                <div className="panel customPanel no-bg">
                    <div className="panel-body">
                        <h3 className="font-300 sm-top0">
                            Students Access Control
                        </h3>
                        <p>
                            This is where you can see all the students for each course and control their access
                        </p>
                        <div className="panel customPanel">
                            <div className="panel-heading border-bottom">
                                <div className="panel-control">
                                    {this.renderSelect()}
                                </div>
                                <h3 className="panel-title">
                                    Students
                                </h3>
                            </div>
                            <div className="panel-body">
                                {this.renderControlsForTable()}

                                {this.renderSearch()}
                                <div className="table-responsive statistic-students table-admin">
                                    <DataTable
                                        keys="id"
                                        columns={this.state.columns}
                                        initialData={students.filter(s => s.Profile)}
                                        useShowHideColumns={true}
                                        initialPageLength={999}
                                        initialSortBy={{ prop: 'name', order: 'descending' }}
                                        pageLengthOptions={[10, 25, 50, 100]}
                                    />
                                    <div className="text-center">
                                    <button className="btn btn-primary" onClick={e => {
                                        this.loadMore();
                                    }}>Load More</button>
                                    </div>
                                </div>
                            </div>
                        </div>


                        {
                            this.props &&
                            <ModalDeletePerson
                                hideModalDelete={this.hideModalDelete}
                                showDeleteUser={this.state.showingDeleteUser}
                                deleteUserConfirmation={this.deleteUserConfirmation}
                                userId={this.state.deleteUserId}
                            />

                        }

                        <div className="panel customPanel">
                            <div className="panel-heading">
                                <h3 className="panel-title">Rules</h3>
                            </div>
                            <div className="panel-body no-padding">
                                <table className="">
                                    <tbody>
                                    <tr>
                                        <td className="v-middle w-sm">Deactivate student if not active for:</td>
                                        <td className="w-xs"><input type="text" className="form-control"/> </td>
                                        <td className="v-middle"><input type="checkbox"/></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }


    }
}

PeopleStudents.propTypes = {
    studentsPeople: PropTypes.array,
    getStudentsData: PropTypes.func.isRequired,
    studentDelete: PropTypes.func,
    editCoursesStudent: PropTypes.func,
    editReferralsStudent: PropTypes.func,
    editAccessStudent: PropTypes.func,
    editNextPaymentStudent: PropTypes.func
};

export default PeopleStudents;


// WEBPACK FOOTER //
// ./src/components/AdminPanel/People/PeopleStudents.js